import '../../sass/database.scss'
import '../../sass/code.scss'
import ItemNavBar from "../common/posts/item-navbar";
import {useEffect, useState} from "react";
import {Post} from "../../common/types/post.types";
import Content from "./content";

function Series(props: Props) {
  const {post} = props;

  const [currentId, setCurrentId] = useState(0);
  const [selectedContent, setSelectedContent] = useState(post.post_indexes[currentId])

  useEffect(() => {
    setSelectedContent(post.post_indexes[currentId])
  }, [currentId])

  const navBar = post.post_indexes.map((item: any, index: number) => {
    return (
      <div onClick={() => setCurrentId(index)} key={index}>
        <ItemNavBar name={item.name} id={index + 1} last_updated={item.updated_at} is_active={currentId === index}/>
      </div>
    )
  })

  return (
    <div className={'series'}>
      <div className={'navbar'}>
        <div className={'list'}>
          {navBar}
        </div>
      </div>
      <div className={'content-component'}>
        <div className={'content'}>
          <Content data={selectedContent.content} />
        </div>
      </div>
    </div>
  )
}

export default Series;

class Props {
  post: Post;
}
